import { setTrackingId } from "client/Misc/utils";
import { ReactElement } from "react";
import "./UnreadCounter.less";

export type UnreadCounterProps = {
	count: number;
};

export const UnreadCounter = (props: UnreadCounterProps): ReactElement => {
	const {
		count
	} = props;

	return (
		<span
			{...setTrackingId("counter")}
			className="unread-counter"
		>
			{count}
		</span>
	);
};

UnreadCounter.displayName = "UnreadCounter";